import styles from './Error.module.css';

function Error() {
  return (
    <article id="error" className={styles.error}>
      <h2>ERROR</h2>
      <p>Something went wrong. Sorry about that! Please reload the page or check back later.</p>
    </article>
  );
}

export default Error;
